import { useNavigate } from 'react-router-dom'
import { Routes } from 'common/constants'
import { requestReportViaEmailUS } from 'common/services/us/us-reports'
import { PostReportRequest } from 'common/types'

import { useMutation } from '@tanstack/react-query'

export const useSendReportViaEmailUS = (reportData: PostReportRequest) => {
  const navigate = useNavigate()

  const {
    data: sendReport,
    isPending: isSendReportLoading,
    isError: isSendReportError,
    mutateAsync: sendReportFn,
  } = useMutation({
    mutationFn: () => requestReportViaEmailUS(reportData),
    onSuccess: () => navigate(Routes.SUCCESS_EMAIL_SENT),
  })

  return {
    sendReport,
    isSendReportLoading,
    isSendReportError,
    sendReportFn,
  }
}
